/* eslint-disable */
/*
    ImageViewer v 1.1.3
    Author: Sudhanshu Yadav
    Copyright (c) 2015-2016 to Sudhanshu Yadav - ignitersworld.com , released under the MIT license.
    Demo on: http://ignitersworld.com/lab/imageViewer.html
*/

/** * picture view plugin ****/
(function($, window, document, undefined) {
    'use strict';

    // an empty function
    var noop = function() {};

    var uniqueId = 0;

    var $body = $('body'),
        $window = $(window),
        $document = $(document);

    // constants
    var ZOOM_CONSTANT = 15; // increase or decrease value for zoom on mouse wheel
    var MOUSE_WHEEL_COUNT = 5; // A mouse delta after which it should stop preventing default behaviour of mouse wheel

    // ease out method
    /*
        t : current time,
        b : intial value,
        c : changed value,
        d : duration
    */
    function easeOutQuart(t, b, c, d) {
        t /= d;
        t--;
        return -c * (t * t * t * t - 1) + b;
    }

    // function to check if image is loaded
    function imageLoaded(img) {
        return img.complete && (typeof img.naturalWidth === 'undefined' || img.naturalWidth !== 0);
    }

    var imageViewHtml = '<div class="iv-image-view"><div class="iv-image-wrap" ></div></div>';

    function Slider(container, options) {
        this.container = container;
        this.onStart = options.onStart || noop;
        this.onMove = options.onMove || noop;
        this.onEnd = options.onEnd || noop;
        this.sliderId = options.sliderId || 'slider' + Math.ceil(Math.random() * 1000000);
    }

    Slider.prototype.init = function() {
        var self = this,
            container = this.container,
            eventSuffix = '.' + this.sliderId;

        // assign event on image wrap
        this.container.on('touchstart' + eventSuffix + ' mousedown' + eventSuffix, function(
            estart
        ) {
            estart.preventDefault();
            var touchMove = (estart.type == 'touchstart' ? 'touchmove' : 'mousemove') + eventSuffix,
                touchEnd = (estart.type == 'touchstart' ? 'touchend' : 'mouseup') + eventSuffix,
                eOrginal = estart.originalEvent,
                sx = eOrginal.clientX || eOrginal.touches[0].clientX,
                sy = eOrginal.clientY || eOrginal.touches[0].clientY;

            var start = self.onStart(estart, {
                x: sx,
                y: sy
            });

            if (start === false) {
                return;
            }

            var moveListener = function(emove) {
                emove.preventDefault();

                eOrginal = emove.originalEvent;

                // get the cordinates
                var mx = eOrginal.clientX || eOrginal.touches[0].clientX,
                    my = eOrginal.clientY || eOrginal.touches[0].clientY;

                self.onMove(emove, {
                    dx: mx - sx,
                    dy: my - sy,
                    mx: mx,
                    my: my
                });
            };

            var endListener = function() {
                $document.off(touchMove, moveListener);
                $document.off(touchEnd, endListener);
                self.onEnd();
            };

            $document.on(touchMove, moveListener);
            $document.on(touchEnd, endListener);
        });

        return this;
    };

    function ImageViewer(container, options) {
        var self = this;

        self.container = container;
        options = self.options = $.extend({}, ImageViewer.defaults, options);

        self.zoomValue = 100;
        container.prepend(imageViewHtml);
        container.addClass('iv-container');

        if (container.css('position') == 'static') {
            container.css('position', 'relative');
        }

        self.imageWrap = container.find('.iv-image-wrap');
        self._viewerId = 'iv' + uniqueId++;

        self._init();
    }

    ImageViewer.prototype = {
        constructor: ImageViewer,
        _init: function() {
            var viewer = this,
                options = viewer.options,
                zooming = false, // tell weather we are zooming trough touch
                container = this.container;

            var eventSuffix = '.' + viewer._viewerId;

            // cache dom refrence
            var imageWrap = this.imageWrap;

            /* Add slide interaction to image*/
            viewer._imageSlider = new Slider(imageWrap, {
                sliderId: viewer._viewerId,
                onStart: function(e, position) {
                    if (!viewer.loaded) {
                        return false;
                    }
                    if (zooming) {
                        return;
                    }
                    var self = this;

                    self.imgWidth = (viewer.imageDim.w * viewer.zoomValue) / 100;
                    self.imgHeight = (viewer.imageDim.h * viewer.zoomValue) / 100;

                    self.positions = [position, position];

                    self.startPosition = viewer.currentImg.position();

                    // clear all animation frame and interval
                    viewer._clearFrames();

                    self.slideMomentumCheck = setInterval(function() {
                        if (!self.currentPos) {
                            return;
                        }
                        self.positions.shift();
                        self.positions.push({
                            x: self.currentPos.mx,
                            y: self.currentPos.my
                        });
                    }, 50);
                },
                onMove: function(e, position) {
                    if (zooming) {
                        return;
                    }
                    this.currentPos = position;

                    var newTop = this.startPosition.top;
                    var newLeft = this.startPosition.left;

                    if (this.imgHeight > viewer.containerDim.h) {
                        newTop += position.dy;
                        newTop = Math.min(newTop, 0);
                        newTop = Math.max(newTop, viewer.containerDim.h - this.imgHeight);
                    }

                    if (this.imgWidth > viewer.containerDim.w) {
                        newLeft += position.dx;
                        newLeft = Math.min(newLeft, 0);
                        newLeft = Math.max(newLeft, viewer.containerDim.w - this.imgWidth);
                    }

                    viewer.currentImg.css({
                        left: newLeft,
                        top: newTop
                    });
                },
                onEnd: function() {
                    if (zooming) {
                        return;
                    }
                    var self = this;

                    var xDiff = this.positions[1].x - this.positions[0].x,
                        yDiff = this.positions[1].y - this.positions[0].y;

                    function momentum() {
                        if (step <= 60) {
                            self.sliderMomentumFrame = requestAnimationFrame(momentum);
                        }

                        positionX = positionX + easeOutQuart(step, xDiff / 3, -xDiff / 3, 60);
                        positionY = positionY + easeOutQuart(step, yDiff / 3, -yDiff / 3, 60);

                        self.onMove(null, {
                            dx: positionX,
                            dy: positionY
                        });
                        step++;
                    }

                    if (Math.abs(xDiff) > 30 || Math.abs(yDiff) > 30) {
                        var step = 1,
                            positionX = self.currentPos.dx,
                            positionY = self.currentPos.dy;

                        momentum();
                    }
                }
            }).init();

            /* Add zoom interation in mouse wheel*/
            var changedDelta = 0;
            imageWrap.on('mousewheel' + eventSuffix + ' DOMMouseScroll' + eventSuffix, function(e) {
                if (!options.zoomOnMouseWheel) {
                    return;
                }

                if (!viewer.loaded) {
                    return;
                }

                // clear all animation frame and interval
                viewer._clearFrames();

                // cross-browser wheel delta
                var delta = Math.max(
                        -1,
                        Math.min(1, e.originalEvent.wheelDelta || -e.originalEvent.detail)
                    ),
                    zoomValue = (viewer.zoomValue * (100 + delta * ZOOM_CONSTANT)) / 100;

                if (!(zoomValue >= 100 && zoomValue <= options.maxZoom)) {
                    changedDelta += Math.abs(delta);
                } else {
                    changedDelta = 0;
                }

                if (changedDelta > MOUSE_WHEEL_COUNT) {
                    return;
                }

                e.preventDefault();

                var contOffset = container.offset(),
                    x = (e.pageX || e.originalEvent.pageX) - contOffset.left,
                    y = (e.pageY || e.originalEvent.pageY) - contOffset.top;

                viewer.zoom(zoomValue, {
                    x: x,
                    y: y
                });
            });

            // apply pinch and zoom feature
            imageWrap.on('touchstart' + eventSuffix, function(estart) {
                if (!viewer.loaded) {
                    return;
                }
                var touch0 = estart.originalEvent.touches[0],
                    touch1 = estart.originalEvent.touches[1];

                if (!(touch0 && touch1)) {
                    return;
                }

                zooming = true;

                var contOffset = container.offset();

                var startdist = Math.sqrt(
                        Math.pow(touch1.pageX - touch0.pageX, 2) +
                            Math.pow(touch1.pageY - touch0.pageY, 2)
                    ),
                    startZoom = viewer.zoomValue,
                    center = {
                        x: (touch1.pageX + touch0.pageX) / 2 - contOffset.left,
                        y: (touch1.pageY + touch0.pageY) / 2 - contOffset.top
                    };

                var moveListener = function(emove) {
                    emove.preventDefault();

                    var touch0 = emove.originalEvent.touches[0],
                        touch1 = emove.originalEvent.touches[1],
                        newDist = Math.sqrt(
                            Math.pow(touch1.pageX - touch0.pageX, 2) +
                                Math.pow(touch1.pageY - touch0.pageY, 2)
                        ),
                        zoomValue = startZoom + (newDist - startdist) / 2;

                    viewer.zoom(zoomValue, center);
                };

                var endListener = function() {
                    $document.off('touchmove', moveListener);
                    $document.off('touchend', endListener);
                    zooming = false;
                };

                $document.on('touchmove', moveListener);
                $document.on('touchend', endListener);
            });

            // handle double tap for zoom in and zoom out
            var touchtime = 0,
                point;
            imageWrap.on('click' + eventSuffix, function(e) {
                if (touchtime == 0) {
                    touchtime = Date.now();
                    point = {
                        x: e.pageX,
                        y: e.pageY
                    };
                } else if (
                    Date.now() - touchtime < 500 &&
                    Math.abs(e.pageX - point.x) < 50 &&
                    Math.abs(e.pageY - point.y) < 50
                ) {
                    if (viewer.zoomValue == options.zoomValue) {
                        viewer.zoom(200);
                    } else {
                        viewer.resetZoom();
                    }
                    touchtime = 0;
                } else {
                    touchtime = 0;
                }
            });

            // calculate elments size on window resize
            if (options.refreshOnResize) {
                $window.on('resize' + eventSuffix, function() {
                    viewer.refresh();
                });
            }
        },

        // method to zoom images
        zoom: function(perc, point) {
            perc = Math.round(Math.max(100, perc));
            perc = Math.min(this.options.maxZoom, perc);

            point = point || {
                x: this.containerDim.w / 2,
                y: this.containerDim.h / 2
            };

            var self = this,
                maxZoom = this.options.maxZoom,
                curPerc = this.zoomValue,
                curImg = this.currentImg,
                containerDim = this.containerDim,
                curLeft = parseFloat(curImg.css('left')),
                curTop = parseFloat(curImg.css('top'));

            self._clearFrames();

            var step = 0;

            // calculate base top,left,bottom,right
            var containerDim = self.containerDim,
                imageDim = self.imageDim;
            var baseLeft = (containerDim.w - imageDim.w) / 2,
                baseTop = (containerDim.h - imageDim.h) / 2,
                baseRight = containerDim.w - baseLeft,
                baseBottom = containerDim.h - baseTop;

            function zoom() {
                step++;

                if (step < 20) {
                    self._zoomFrame = requestAnimationFrame(zoom);
                }

                var tickZoom = easeOutQuart(step, curPerc, perc - curPerc, 20);

                var ratio = tickZoom / curPerc,
                    imgWidth = (self.imageDim.w * tickZoom) / 100,
                    imgHeight = (self.imageDim.h * tickZoom) / 100,
                    newLeft = -((point.x - curLeft) * ratio - point.x),
                    newTop = -((point.y - curTop) * ratio - point.y);

                // fix for left and top
                newLeft = Math.min(newLeft, baseLeft);
                newTop = Math.min(newTop, baseTop);

                // fix for right and bottom
                if (newLeft + imgWidth < baseRight) {
                    newLeft = baseRight - imgWidth; // newLeft - (newLeft + imgWidth - baseRight)
                }

                if (newTop + imgHeight < baseBottom) {
                    newTop = baseBottom - imgHeight; // newTop + (newTop + imgHeight - baseBottom)
                }

                curImg.css({
                    height: imgHeight + 'px',
                    width: imgWidth + 'px',
                    left: newLeft + 'px',
                    top: newTop + 'px'
                });

                self.zoomValue = tickZoom;
            }

            zoom();
        },
        _clearFrames: function() {
            clearInterval(this._imageSlider.slideMomentumCheck);
            cancelAnimationFrame(this._imageSlider.sliderMomentumFrame);
            cancelAnimationFrame(this._zoomFrame);
        },
        resetZoom: function() {
            this.zoom(this.options.zoomValue);
        },
        // calculate dimensions of image, container and reset the image
        _calculateDimensions: function() {
            // calculate content width of image
            var self = this,
                curImg = self.currentImg,
                container = self.container,
                imageWidth = curImg.width(),
                imageHeight = curImg.height(),
                contWidth = container.width(),
                contHeight = container.height();

            // set the container dimension
            self.containerDim = {
                w: contWidth,
                h: contHeight
            };

            // set the image dimension
            var imgWidth,
                imgHeight,
                ratio = imageWidth / imageHeight;

            imgWidth =
                (imageWidth > imageHeight && contHeight >= contWidth) ||
                ratio * contHeight > contWidth
                    ? contWidth
                    : ratio * contHeight;

            imgHeight = imgWidth / ratio;

            self.imageDim = {
                w: imgWidth,
                h: imgHeight
            };

            // reset image position and zoom
            curImg.css({
                width: imgWidth + 'px',
                height: imgHeight + 'px',
                left: (contWidth - imgWidth) / 2 + 'px',
                top: (contHeight - imgHeight) / 2 + 'px',
                'max-width': 'none',
                'max-height': 'none'
            });
        },
        refresh: function() {
            if (!this.loaded) {
                return;
            }
            this._calculateDimensions();
            this.resetZoom();
        },
        options: function(key, value) {
            if (!value) {
                return this.options[key];
            }

            this.options[key] = value;
        },
        destroy: function(key, value) {
            var eventSuffix = '.' + this._viewerId;
            this.container.remove('[class^="iv"]');
            $window.off(eventSuffix);
            return null;
        },
        load: function(image, loadedCallback) {
            var self = this,
                container = this.container;

            container.find('.iv-large-image').remove();
            this.imageWrap.prepend('<img class="iv-large-image" src="' + image + '" />');

            var currentImg = (this.currentImg = this.container.find('.iv-large-image'));
            self.loaded = false;

            // hide until loaded
            currentImg.hide();

            // refresh the view
            function refreshView() {
                self.loaded = true;
                self.zoomValue = 100;

                // reset zoom of images
                currentImg.show();
                self.refresh();
                self.resetZoom();
                loadedCallback();
            }

            if (imageLoaded(currentImg[0])) {
                refreshView();
            } else {
                $(currentImg[0]).on('load', refreshView);
            }
        }
    };

    ImageViewer.defaults = {
        zoomValue: 100,
        maxZoom: 500,
        refreshOnResize: true,
        zoomOnMouseWheel: true
    };

    // export ImageViewer
    define(function() {
        return ImageViewer;
    });
})(window.jQuery, window, document);
